import { QueryClient } from "react-query";

const client = new QueryClient();
export default function getQueryClient(): QueryClient {
    return client
}